


/**
 * Returns random integer between provided bounds.
 */
export const inRange = (min: number, max: number) => {
    max = Math.floor(max);
    min = Math.ceil(min);

    return Math.floor(Math.random() * (max - min + 1) + min);
};